import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const TicketPropertiesEnabledTooltipMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: 'editor.options.payment.ticketPropertiesEnabledTooltip'
});
export default TicketPropertiesEnabledTooltipMessage;